








import { createComponent } from "@vue/composition-api";
export default createComponent({
  props: {
    textValue: {
      type: String,
      required: true
    }
  }
});
